export default __webpack_public_path__ + "static/media/schultz-logo.10def5f3.png";